import React from "react";
import { ChevronDown } from "lucide-react";

/**
 * Native <select> wrapper styled to match the shadcn SelectTrigger.
 * Uses the browser's native picker — guaranteed responsive on every mobile
 * device and dark-mode keyboard. Use this instead of the Radix Select when
 * the filter is critical and must "just work" everywhere.
 *
 *   <NativeSelect
 *     data-testid="filter-country"
 *     value={country || "all"}
 *     onValueChange={(v) => setCountry(v)}
 *     placeholder="Any"
 *   >
 *     <option value="all">Any</option>
 *     {countries.map((c) => <option key={c} value={c}>{c}</option>)}
 *   </NativeSelect>
 */
export const NativeSelect = React.forwardRef(function NativeSelect(
  { value, onValueChange, children, className = "", "data-testid": testId, placeholder, ...rest },
  ref,
) {
  return (
    <div className={`relative ${className}`}>
      <select
        ref={ref}
        value={value}
        onChange={(e) => onValueChange?.(e.target.value)}
        data-testid={testId}
        className="appearance-none w-full h-11 rounded-md border border-input bg-background px-3 pr-9 text-sm font-sans-ui focus:outline-none focus:ring-2 focus:ring-[#C05A3C]/30 focus:border-[#C05A3C] disabled:cursor-not-allowed disabled:opacity-50"
        style={{ WebkitAppearance: "none", MozAppearance: "none", touchAction: "manipulation" }}
        {...rest}
      >
        {placeholder !== undefined && <option value="" disabled hidden>{placeholder}</option>}
        {children}
      </select>
      <ChevronDown className="w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
    </div>
  );
});

export default NativeSelect;
